var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('SignUpThanksPage',{attrs:{"npi_status":_vm.npi_status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }